var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progress-bar" }, [
    _c("i", { staticClass: "progress-indicator", style: _vm.progressStatus }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }